import { useState } from 'react';
import { BabyName } from '@london-life/contracts';

// a name, then one button to ask (a baby, an adoption, a child's new name): the same rules as a player's name
export function NameAsk({
  label,
  placeholder,
  hint,
  cta,
  busy,
  onAsk,
}: {
  label: string;
  placeholder: string;
  hint: string;
  cta: string;
  busy: boolean;
  onAsk: (name: string) => void;
}) {
  const [name, setName] = useState('');
  const checked = BabyName.safeParse(name);
  const problem = name.trim() && !checked.success ? (checked.error.issues[0]?.message ?? 'Choose another name') : null;
  return (
    <div className="family-name">
      <label className="railco-field">
        <span>{label}</span>
        <input
          value={name}
          maxLength={20}
          placeholder={placeholder}
          onChange={(event) => setName(event.target.value)}
        />
        <small className={problem ? 'railco-problem' : ''}>{problem ?? hint}</small>
      </label>
      <button
        type="button"
        className="city-card-go"
        disabled={busy || !checked.success}
        onClick={() => checked.success && onAsk(checked.data)}
      >
        {cta}
      </button>
    </div>
  );
}
